import { useState, useEffect } from "react"

const defaultFilters = { expected: true, actual: true, desired: true }

export function useFilters() {
  const [filters, setFilters] = useState(() => {
    try {
      const saved = localStorage.getItem("insightsFilters")
      return saved ? JSON.parse(saved) : defaultFilters
    } catch {
      return defaultFilters
    }
  })

  useEffect(() => {
    localStorage.setItem("insightsFilters", JSON.stringify(filters))
  }, [filters])

  return [filters, setFilters]
}

const SOURCE_COLORS = {
  expected: "bg-green-100 text-green-800 border-green-300",
  actual: "bg-blue-100 text-blue-800 border-blue-300",
  desired: "bg-purple-100 text-purple-800 border-purple-300"
}

export default function SourceFilter({ filters, onChange }) {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      return localStorage.getItem("sourceFilterCollapsed") === "true"
    } catch {
      return false
    }
  })

  const toggleCollapse = () => {
    const newState = !isCollapsed
    setIsCollapsed(newState)
    localStorage.setItem("sourceFilterCollapsed", String(newState))
  }

  const activeCount = Object.values(filters).filter(Boolean).length

  return (
    <div className={`filter-panel source-filter-panel ${isCollapsed ? "collapsed" : ""}`}>
      <button
        type="button"
        className="filter-panel-header"
        onClick={toggleCollapse}
      >
        <span className="filter-panel-title">Sources</span>
        {isCollapsed && <span className="filter-panel-badge">{activeCount}/3</span>}
        <span className="filter-panel-chevron">{isCollapsed ? "+" : "-"}</span>
      </button>
      {!isCollapsed && (
        <div className="filter-panel-content">
          {["expected", "actual", "desired"].map((source) => (
            <label
              key={source}
              className={`source-filter-item ${
                filters[source]
                  ? SOURCE_COLORS[source]
                  : "bg-gray-100 text-gray-400 border-gray-200"
              }`}
            >
              <input
                type="checkbox"
                checked={filters[source]}
                onChange={(e) => onChange({ ...filters, [source]: e.target.checked })}
                className="sr-only"
              />
              <span className="capitalize text-sm font-medium">{source}</span>
              {filters[source] && (
                <span className="text-xs">✓</span>
              )}
            </label>
          ))}
        </div>
      )}
    </div>
  )
}
